module.exports = __webpack_public_path__ + "img/registered.51e75ec5.png";